import React from "react";

const DashboardHeadphoneSVG = ({ className }) => {
  return (
    <svg
      width="108"
      height="108"
      viewBox="0 0 108 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M67.4589 103.374C64.8153 103.374 62.6718 101.231 62.6718 98.5871C62.6718 95.9428 64.8153 93.7999 67.4589 93.7999C76.9255 93.7999 84.6268 86.0981 84.6268 76.6315V44.197C84.6268 25.3883 69.3251 10.086 50.5165 10.086C31.7079 10.086 16.4063 25.3883 16.4063 44.197V61.1388C16.4063 63.7831 14.2628 65.926 11.6192 65.926C8.9755 65.926 6.83203 63.7831 6.83203 61.1388V44.197C6.83203 20.1091 26.4288 0.511719 50.5165 0.511719C74.6043 0.511719 94.201 20.1085 94.201 44.197V76.6315C94.2016 91.3773 82.2053 103.374 67.4589 103.374Z"
        fill="var(--bs-primary-700)"
      />
      <path
        d="M11.828 80.4861H11.4074C5.48715 80.4861 0.6875 75.6865 0.6875 69.7662V52.0832C0.6875 46.163 5.48715 41.3633 11.4074 41.3633H11.828C17.7483 41.3633 22.5479 46.163 22.5479 52.0832V69.7662C22.5479 75.6865 17.7483 80.4861 11.828 80.4861Z"
        fill="var(--bs-primary-700)"
      />
      <path
        d="M89.621 80.4861H89.2003C83.2801 80.4861 78.4805 75.6865 78.4805 69.7662V52.0832C78.4805 46.163 83.2801 41.3633 89.2003 41.3633H89.621C95.5412 41.3633 100.341 46.163 100.341 52.0832V69.7662C100.341 75.6865 95.5412 80.4861 89.621 80.4861Z"
        fill="var(--bs-primary-700)"
      />
      <path
        d="M13.707 41.5664C13.8385 42.2438 13.9123 42.9424 13.9123 43.6579V60.9203C13.9123 66.957 9.01878 71.8505 2.98213 71.8505C2.26597 71.8505 1.56797 71.7767 0.890625 71.6452C1.86721 76.6803 6.29499 80.4833 11.6155 80.4833C17.6521 80.4833 22.5457 75.5897 22.5457 69.5531V52.2907C22.5451 46.9708 18.742 42.543 13.707 41.5664Z"
        fill="var(--bs-primary-600)"
      />
      <path
        d="M91.5 41.5664C91.6314 42.2438 91.7053 42.9424 91.7053 43.6579V60.9203C91.7053 66.957 86.8118 71.8505 80.7751 71.8505C80.0589 71.8505 79.3609 71.7767 78.6836 71.6452C79.6602 76.6803 84.088 80.4833 89.4085 80.4833C95.4451 80.4833 100.339 75.5897 100.339 69.5531V52.2907C100.339 46.9708 96.535 42.543 91.5 41.5664Z"
        fill="var(--bs-primary-600)"
      />
      <path
        d="M62.1511 107.427C68.3647 107.427 73.4018 103.469 73.4018 98.5874C73.4018 93.7056 68.3647 89.748 62.1511 89.748C55.9375 89.748 50.9004 93.7056 50.9004 98.5874C50.9004 103.469 55.9375 107.427 62.1511 107.427Z"
        fill="var(--bs-primary-700)"
      />
      <path
        d="M67.1352 90.6719C67.3118 91.2935 67.4125 91.9383 67.4125 92.6019C67.4125 97.4835 62.375 101.441 56.1618 101.441C54.367 101.441 52.6774 101.103 51.1719 100.515C52.2937 104.468 56.7766 107.425 62.1459 107.425C68.3597 107.425 73.3966 103.468 73.3966 98.586C73.3966 95.1141 70.8425 92.118 67.1352 90.6719Z"
        fill="var(--bs-primary-600)"
      />
      <path
        d="M68.5273 61.3776C68.5273 72.2781 77.3638 81.1146 88.2643 81.1146L89.9569 61.3776L88.2643 41.6406C77.3638 41.6406 68.5273 50.4773 68.5273 61.3776Z"
        fill="#FFD748"
      />
      <path
        d="M88.2578 41.6406V81.1146C99.1583 81.1146 107.995 72.2781 107.995 61.3776C107.995 50.4771 99.1583 41.6406 88.2578 41.6406Z"
        fill="#FFC335"
      />
      <path
        d="M85.6641 60.538V70.813C85.6641 72.2448 86.8248 73.4056 88.2566 73.4056L89.9852 65.6755L88.2566 57.9453C86.8248 57.9455 85.6641 59.1063 85.6641 60.538Z"
        fill="#FAF7FC"
      />
      <path
        d="M88.2578 57.9453V73.4054C89.6896 73.4054 90.8504 72.2447 90.8504 70.8129V60.5379C90.8504 59.1061 89.6896 57.9453 88.2578 57.9453Z"
        fill="#EFEDF4"
      />
      <path
        d="M88.2566 54.5601C89.6885 54.5601 90.8492 53.3994 90.8492 51.9676C90.8492 50.5357 89.6885 49.375 88.2566 49.375C86.8248 49.375 85.6641 50.5357 85.6641 51.9676C85.6641 53.3994 86.8248 54.5601 88.2566 54.5601Z"
        fill="#FAF7FC"
      />
    </svg>
  );
};

export default DashboardHeadphoneSVG;
